import type { CountryCode } from '$gql/storefront/schemas';
import { isCountryCode } from '$gql/storefront/utils';
import { fetchGeolocation } from '$lib/region';
import { asyncReadable } from '@square/svelte-store';

type UserGeolocation = {
  country?: CountryCode;
  regionCode?: string;
  regionName?: string;
  city?: string;
};

export const geolocation = asyncReadable<UserGeolocation | null>(null, async () => {
  const data = await fetchGeolocation();

  const country = data.country_code?.toUpperCase();

  if (!country || !isCountryCode(country)) return null;

  return {
    country,
    city: data.city || undefined,
    regionCode: data.region_code || undefined,
    regionName: data.region_name || undefined
  };
});
